export const errorMessages = {
  email: 'This email already exists in the system.',
  limit: 'You have exceeded the invitation limit. Please reach out to your account manager for assistance.',
};

export default {};
